<template>
  <v-app v-if="$icsilab.getDatas()" style="height: 100%;width: 100%">
    <fx-header v-if="$icsilab.getHeader()" @menuClick="$icsilab.setDrawerEtat(true)"/>
    <v-main style="width: 100%;height: 100%">
      <keep-alive>
        <router-view id="myApp"></router-view>
      </keep-alive>
      <cx-cookie-accept/>
    </v-main>
    <fx-footer v-if="$icsilab.getFooter()"></fx-footer>
    <fx-menu v-model="$icsilab.store.state.drawerMenu"></fx-menu>
  </v-app>
</template>
<script>
import FxMenu from "./components/commun/FxMenu";
import FxHeader from "./components/commun/FxHeader";
import FxFooter from "./components/commun/FxFooter";
import CxCookieAccept from "@/components/commun/CxCookieAccept";

export default {
  name: 'App',
  components: {CxCookieAccept, FxFooter, FxHeader, FxMenu},
  data() {
    return {
      drawer: false
    }
  },
}
</script>
<style>
  html,body {
    height: 100%;
    width: 100%;
  }

  ::-webkit-scrollbar {
    width: 0 !important;
  }

  #myApp {
    width: 100%;
    height: 100%;
    padding: 0;
    min-height: inherit;
    max-height: inherit;
    box-sizing: border-box;
    overflow:auto;
  }
</style>
